import React, { useState } from "react";
import "./Footer.css";
import GetStartedSection from "./GetStartedSection";
import { Link } from "react-router-dom";

const Footer = ({ showGetStarted = true }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  return (
    <div className="no-print" style={{ width: "100%" }}>
      {showGetStarted && <GetStartedSection />}

      <footer className="site-footer">
        <div className="footer-top-line">
          <Link to="/" id="logo">
            <img src="/images/logo_footer.png" alt="Acorn 로고" />
          </Link>
          <div className="extra-information">
            <a href="/About">회사소개</a>
            <a
              href="/privacy-popup"
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  "/privacy-popup",
                  "PrivacyPopup",
                  "width=800,height=800,resizable=yes,scrollbars=yes"
                );
              }}
            >
              이용약관 및 개인정보 처리방침
            </a>
            <Link to="/" state={{ scrollToFAQ: true }}>
              자주 묻는 질문
            </Link>
          </div>
          <div className="social-media-icons">
            <a
              href="https://www.youtube.com/@official.acornpub"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/youtube-logo.png" alt="youtube"></img>
            </a>
            <a
              href="https://www.instagram.com/acorn_pub/?igsh=MWxjNWdlZmUzZDB5cQ%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/instagram-logo.png" alt="instagram"></img>
            </a>
            <a
              href="https://www.linkedin.com/in/acornpub365"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/linkedIn.png" alt="linkedin"></img>
            </a>            
            <a
              href="https://www.facebook.com/acornpub/?locale=ko_KR"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/facebook-logo.png" alt="facebook"></img>
            </a>
            <a
              href="https://x.com/acornpublisher"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/acornx.png" alt="acornx"></img>
            </a>
            <a
              href="https://pf.kakao.com/_nmwJn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/kakao-logo.png" alt="kakao"></img>
            </a>
            <a
              href="https://page.stibee.com/subscriptions/361788"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/acorn_newsletter.png" alt="acorn_newsletter"></img>
            </a>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div
          className="footer-accordion-toggle"
          onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        >
          <span>회사 정보</span>
          <span
            className={`footer-arrow ${isAccordionOpen ? "open" : ""}`}
          ></span>
        </div>

        <div className={`footer-bottom-line ${isAccordionOpen ? "open" : ""}`}>
          <div className="container">
            <div className="item1">
              <h4>전화문의</h4>
            </div>
            <div className="item2">
              <p>02-2653-7600</p>
              <p className="note">(평일 09:00~18:00, 12~13시 제외)</p>
            </div>
          </div>
          <div className="container">
            <div className="item1">
              <h4>팩스</h4>
            </div>
            <div className="item2">
              <p>02-2653-0433</p>
            </div>
          </div>
          <div className="container">
            <div className="item1">
              <h4>주소</h4>
            </div>
            <div className="item2">
              <p>(48939) 부산광역시 중구 중앙대로 88, 6층 606호(중앙동4가, 은산베이빌딩)</p>
            </div>
          </div>
          <div className="container">
            <div className="item1">
              <h4>메일문의</h4>
            </div>
            <div className="item2">
              <p>acornpub@acornpub.co.kr</p>
              <p className="note">(24시간 내 답변, 공휴일 제외)</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
